"use client";

import { c as _c } from "react/compiler-runtime";
import { useRouter as usePagesRouter } from "next/compat/router";
import { useRouter as useAppRouter, usePathname, useSearchParams } from "next/navigation";
import { buildUrlFromPathAndQuery } from "./query-string";
type NavOptions = {
  scroll?: boolean;
  shallow?: boolean;
};
type QueryValue = string | Array<string> | undefined;
export const useCompatRouter = () => {
  const $ = _c(20);
  const pagesRouter = usePagesRouter();
  const appRouter = useAppRouter();
  const pathname = usePathname();
  const searchParameters = useSearchParams();
  let t0;
  if ($[0] !== searchParameters) {
    t0 = () => {
      if (!searchParameters) {
        return {};
      }
      return Object.fromEntries(searchParameters.entries());
    };
    $[0] = searchParameters;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const getAppCurrentQuery = t0;
  let t1;
  if ($[2] !== searchParameters) {
    bb0: {
      const result = {};
      if (!searchParameters) {
        t1 = result;
        break bb0;
      }
      for (const [key, value] of searchParameters.entries()) {
        if (key in result) {
          const previous = result[key];
          result[key] = Array.isArray(previous) ? [...previous, value] : [previous as string, value];
        } else {
          result[key] = value;
        }
      }
      t1 = result;
    }
    $[2] = searchParameters;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const query = t1;
  let t2;
  if ($[4] !== appRouter || $[5] !== getAppCurrentQuery || $[6] !== pagesRouter) {
    t2 = (pathname_0, t3, t4) => {
      const query_0 = t3 === undefined ? {} : t3;
      const options = t4 === undefined ? {} : t4;
      if (pagesRouter) {
        const url = typeof pathname_0 === "string" ? {
          pathname: pathname_0,
          query: query_0
        } : pathname_0;
        return pagesRouter.push(url, undefined, options);
      }
      if (options.shallow === true && typeof window !== "undefined") {
        const url_0 = buildUrlFromPathAndQuery(window.location.pathname, query_0);
        window.history.pushState({}, "", url_0);
        if (options.scroll) {
          window.scrollTo({
            top: 0
          });
        }
        return;
      }
      const url_1 = buildUrlFromPathAndQuery(pathname_0, {
        ...getAppCurrentQuery(),
        ...query_0
      });
      appRouter.push(url_1, {
        scroll: options.scroll ?? true
      });
    };
    $[4] = appRouter;
    $[5] = getAppCurrentQuery;
    $[6] = pagesRouter;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const push = t2;
  let t3;
  if ($[8] !== appRouter || $[9] !== getAppCurrentQuery || $[10] !== pagesRouter) {
    t3 = (pathname_1, t4, t5) => {
      const query_1 = t4 === undefined ? {} : t4;
      const options_0 = t5 === undefined ? {} : t5;
      if (pagesRouter) {
        const url_2 = typeof pathname_1 === "string" ? {
          pathname: pathname_1,
          query: query_1
        } : pathname_1;
        return pagesRouter.replace(url_2, undefined, options_0);
      }
      if (options_0.shallow === true && typeof window !== "undefined") {
        const url_3 = buildUrlFromPathAndQuery(window.location.pathname, query_1);
        window.history.replaceState({}, "", url_3);
        if (options_0.scroll) {
          window.scrollTo({
            top: 0
          });
        }
        return;
      }
      const url_4 = buildUrlFromPathAndQuery(pathname_1, {
        ...getAppCurrentQuery(),
        ...query_1
      });
      appRouter.replace(url_4, {
        scroll: options_0.scroll ?? true
      });
    };
    $[8] = appRouter;
    $[9] = getAppCurrentQuery;
    $[10] = pagesRouter;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const replace = t3;
  const t4 = Boolean(pagesRouter);
  let t5;
  if ($[12] !== appRouter || $[13] !== pagesRouter || $[14] !== pathname || $[15] !== push || $[16] !== query || $[17] !== replace || $[18] !== t4) {
    t5 = {
      ...pagesRouter,
      ...appRouter,
      query,
      pathname,
      push,
      replace,
      locale: "fa",
      isAppRouter: t4
    };
    $[12] = appRouter;
    $[13] = pagesRouter;
    $[14] = pathname;
    $[15] = push;
    $[16] = query;
    $[17] = replace;
    $[18] = t4;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
};